<template>
  <Adminlte>
    <p>
      <button class="btn btn-sm btn-success" @click="createNews()"><i class="fa fa-plus"></i>&nbsp Novo</button>
    </p>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Notícias</h3>
      </div>
      <div class="box-body">
        <DataTables
          tableId="news-table"
          :url="this.apiUrl"
          :columns="this.columns"
          :columnDefs="this.columnDefs"
          :order="[[1, 'desc']]"
        >
        </DataTables>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
    <div class="modal fade" id="delete-news-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Excluir Notícia</h4>
          </div>
          <div class="modal-body">
            <p>
              Ao clicar em "Ok" a notícia será excluída do sistema.
              Esta ação é irreversível! Deseja continuar?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="delete-news-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
import DataTables from '@/components/elements/DataTables'
import DateFormatter from '@/services/date_formatter'
import { BackendApi } from '@/services/backend_api'
import Notifier from '@/components/elements/Notifier'

export default {
  name: 'NewsHome',
  components: { Adminlte, Notifier, DataTables },
  data: function () {
    return {
      apiUrl: process.env.API_URL + 'news',
      columns: [
        { label: 'Titulo', field: 'title' },
        { label: 'Data', field: 'dateTime' },
        { label: 'Opções', field: null }
      ],
      columnDefs: [
        {
          targets: 1,
          render: DateFormatter.formatIsoDate
        },
        {
          targets: 2,
          orderable: false,
          render: function (data, type, full, meta) {
            return `
            <button
              class="btn btn-xs btn-primary edit-news"
              data-news-id=` + data.id + `>
                <i class="fa fa-pencil"></i>
                &nbsp; Editar
            </button>
            <button
              class="btn btn-xs btn-danger delete-news"
              data-news-id=` + data.id + `
              data-toggle="modal"
              data-target="#delete-news-modal">
              <i class="fa fa-close"></i>
              &nbsp; Excluir
            </button>
            `
          }
        }
      ],
      deleteNewsId: null
    }
  },
  mounted () {
    this.bindConfirmDeleteNews()
    this.bindEditNewsButtonClick()
    this.bindDeleteNewsButtonClick()
  },
  methods: {
    createNews () {
      this.$router.push({name: 'CreateNews'})
    },
    bindEditNewsButtonClick () {
      let that = this
      $('body').off('click', '.edit-news')
      .on('click', '.edit-news', function (e) {
        const newsId = $(this).data('news-id')
        that.editNews(newsId)
      })
    },
    editNews (id) {
      this.$router.push({name: 'EditNews', params: { id: id }})
    },
    bindDeleteNewsButtonClick () {
      let that = this
      $('body').off('click', '.delete-news')
      .on('click', '.delete-news', function (e) {
        that.deleteNewsId = $(this).data('news-id')
      })
    },
    bindConfirmDeleteNews () {
      let that = this
      $('body').off('click', '#delete-news-modal-confirm')
        .on('click', '#delete-news-modal-confirm', function (e) {
          that.deleteNews()
        })
    },
    deleteNews () {
      BackendApi.getClient().delete(`news/${this.deleteNewsId}`)
        .then(response => {
          this.reloadTable()
          this.showNewsDeleteSuccessNotification()
        })
        .catch(e => {
          this.showNewsDeleteErrorNotification()
        })
    },
    reloadTable () {
      $('#news-table').DataTable().ajax.reload()
    },
    showNewsDeleteSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A notícia foi excluída do sistema!' })
    },
    showNewsDeleteErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir a notícia! Entre em contato com a equipe de desenvolvimento.' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewsHome.vue?f50da1f2